var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasColor)?_c('span',{style:(_vm.colorStyle)},[_c(_vm.icon,{tag:"component"})],1):_c(_vm.icon,{tag:"component"})}
var staticRenderFns = []

export { render, staticRenderFns }